jQuery( document ).ready(function() {
    jQuery('.preview-player').prepend('<button class="play" aria-hidden="true">play</button><button class="pause" aria-hidden="true">pause</button><span>Preview</span>');
    //
    jQuery('.audio-preview').on('click', function () {
        jQuery('audio').trigger('pause');
        if(jQuery(this).hasClass('active')) { // if is playing
            jQuery(this).find('audio').trigger('pause');
            jQuery('.audio-preview').removeClass('active');
        } else { // if is not playing
            jQuery(this).find('audio').trigger('play');
            jQuery('.audio-preview').removeClass('active');
            jQuery(this).addClass('active');
        }
    });
    
});
